import styled from "styled-components";
import userIcon from './../../_static/icons/avatar0.png';

export const Background = styled.div`
    position: relative;
    width: 98%;
    max-width: 90%;
    margin: 30vh auto 60px;
    padding: 30px 20px 30px;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
    
    .contract-info {
        p {
            color: #0070f3;
            font-size: 12px;
        }
    }
`;

export const UserPhoto = styled.div`
    position: relative;
    padding: 40px 20px 60px;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);    
    
    .user-image {
        background: url(${userIcon});
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        width: 120px;
        height: 120px;
        margin-left: 10px;
        float: right;
        border-style: solid;
        border-width: 1px;
        border-color: #f0f;
        border-radius: 60px;
    }   
    
`;

export const UserData = styled.div`
    position: relative;
    padding: 30px 20px 60px;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
    
    Button {
        background-color: #263F7A !important;
    }
    
    #partner-folio {
        font-size: 20px;
    }
`;